module.exports = __webpack_public_path__ + "img/07-cross.18448e38.svg";